import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Animation	      Effet
// fade-up	         Apparition vers le haut
// fade-down	      Apparition vers le bas
// fade-left	      Apparition depuis la gauche
// fade-right	      Apparition depuis la droite
// zoom-in	         Zoom avant
// flip-up	         Flip vertical

const AnimatedSection = ({
  children,
  animation = 'fade-up', //Par défaut
  delay = 1000,
  duration = 800,
  ...props
}) => {
  useEffect(() => {
    AOS.refresh(); // Rafraîchit AOS après le rendu
  }, []);

  return (
    <div
      data-aos={animation}
      data-aos-delay={delay}
      data-aos-duration={duration}
      data-aos-once="true"
      data-aos-anchor-placement="top-center"
      {...props}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;